// extracted by mini-css-extract-plugin
export var photos = "index-module--photos--qdyTF";
export var photo = "index-module--photo--BX-1-";
export var fadein = "index-module--fadein--fCPZ9";